<template>
  <div class="box-ui-select" :class="{'searchbar-content': inSrch}">
    <select v-for="(sel, index) in sels" :key="index" :id="`srchSel${index}`" @change="onChange">
      <option v-for="(opt, index) in sel" :key="index" :value="opt.value">{{ opt.text }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'UiSelect',
  props: ['selectOptions', 'inSrch'],
  data () {
    return {
      sels: []
    }
  },
  created () {
    this.optsRework()
  },
  methods: {
    optsRework () {
      // console.log(this.selectOptions)
      const i18nTitle = 'searchBar.select.title'
      const i18nOrders = 'searchBar.select.orders'
      for (const prop of this.selectOptions) {
        const _sels = []
        if (prop.useAll) {
          _sels.push(this.$t(`${i18nTitle}.all`))
        }
        for (const opt of prop.opts) {
          const optObj = {
            text: this.$t(`${i18nTitle}.${opt['text']}`),
            value:opt.value
          }
          if (opt.orders) {
            for (const ord of opt.orders) {
              _sels.push(text + ' ' + this.$t(`${i18nOrders}.${ord}`))
            }
          } else {
            _sels.push(optObj)
          }
        }
        this.sels.push(_sels)
      }
    },
    onChange(event){
      const targetVal = event.target.value
      console.log(targetVal)
      this.$emit('onSelect', targetVal)
    }
  }
}
</script>

<style scoped>
.box-ui-select {
  display: flex;
  align-content: center;
}
.plural select {
  margin-right: 5px;
}
.plural select:last-child {
  margin: 0;
}
select {
  padding: 5px;
  font-weight: 700;
  font-size: 0.75em;
  border: 1px solid #737373;
  height: 26px;
  margin-right:4px;
}
.box-ui-select select:last-child{
  margin-right:0;
}
.searchbar-content select{
  min-width: 135px;
}
.search-filter select{
  min-width:unset;
}
</style>
